import ProgressSpinner from './progress-spinner';

export { ProgressSpinner };

export default ProgressSpinner;
